module.exports = __webpack_public_path__ + "img/capa-livro-page-42-especies.6db0618e.jpg";